import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { Country } from '~/Api/Country';
import {
	selectDataSourceCountries,
	selectDataSourcesByCountry,
	State as DataSourceState,
} from '~/MedicinalBrandsAnalytics/DataSource';
import {
	RegionAvailability,
	selectRegionAvailabilities,
	State as RegionState,
} from '~/MedicinalBrandsAnalytics/Region';

import RegionSelect from './RegionSelect';

interface State {
	medicinalBrandsAnalyticsRegion: RegionState;
	medicinalBrandsAnalyticsDataSource: DataSourceState;
}

const memoizedselectDataSourceCountries = memoizeOne(selectDataSourceCountries);

function mapStateToProps({ medicinalBrandsAnalyticsRegion, medicinalBrandsAnalyticsDataSource }: State): {
	regionAvailabilities: RegionAvailability[] | null;
	countries: Country[] | null;
} {
	return {
		regionAvailabilities: selectRegionAvailabilities(
			medicinalBrandsAnalyticsRegion,
			selectDataSourcesByCountry(medicinalBrandsAnalyticsDataSource.dataSources || [])
		),
		countries: memoizedselectDataSourceCountries(medicinalBrandsAnalyticsDataSource.dataSources || []),
	};
}

export default connect(mapStateToProps)(RegionSelect);
